"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = __importDefault(require("../Icon"));
var VideoPlayerOverlay = function (_a) {
    var playing = _a.playing, error = _a.error, onClick = _a.onClick;
    if (error) {
        return (react_1.default.createElement("div", { className: "ui-video-player-error" },
            react_1.default.createElement(Icon_1.default, { icon: 'error', size: "xxlarge" }),
            react_1.default.createElement("span", null,
                "Sorry, Fail to load the video. ",
                react_1.default.createElement("br", null),
                " Please check your network connection ",
                react_1.default.createElement("br", null),
                " and try again.")));
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-video-player-overlay", !playing ? "ui-video-player-overlay-paused" : null), "data-testid": "overlay", role: "button", onClick: onClick }, playing ? react_1.default.createElement(Icon_1.default, { icon: 'pause', size: "xxxlarge", fill: true }) : react_1.default.createElement(Icon_1.default, { icon: 'play_arrow', size: "xxxlarge", fill: true })));
};
exports.default = VideoPlayerOverlay;
